__turbopack_context__.v({
  "chevron": "bmUmPG_chevron",
  "details": "bmUmPG_details",
  "empty-star": "bmUmPG_empty-star",
  "hidden-mobile": "bmUmPG_hidden-mobile",
  "left-container": "bmUmPG_left-container",
  "logo": "bmUmPG_logo",
  "logo-container": "bmUmPG_logo-container",
  "logo-text": "bmUmPG_logo-text",
  "logo-title": "bmUmPG_logo-title",
  "mobile-controls": "bmUmPG_mobile-controls",
  "name": "bmUmPG_name",
  "quotation-icon": "bmUmPG_quotation-icon",
  "rating": "bmUmPG_rating",
  "rating-container": "bmUmPG_rating-container",
  "review": "bmUmPG_review",
  "review-item": "bmUmPG_review-item",
  "reviews": "bmUmPG_reviews",
  "reviews-container": "bmUmPG_reviews-container",
  "right-container": "bmUmPG_right-container",
  "scroll-left": "bmUmPG_scroll-left",
  "scroll-right": "bmUmPG_scroll-right",
  "scrollLeft": "bmUmPG_scrollLeft",
  "scrollRight": "bmUmPG_scrollRight",
  "show-mobile": "bmUmPG_show-mobile",
  "source": "bmUmPG_source",
  "star": "bmUmPG_star",
  "stars": "bmUmPG_stars",
  "text": "bmUmPG_text",
  "title": "bmUmPG_title",
});
